/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable no-mixed-operators */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
/* eslint-disable import/extensions */
import { END } from "redux-saga";
import { loadSelf } from "@fdn/profile_store";
import Env from "Consts/env";
import cookie from "cookie";
import dynamic from "next/dynamic";
import { wrapper } from "@/Store/index";
import { loadCategoryDesktop } from "@/Store/category_desktop_store/lib/actions";

const Layout = dynamic(
	() => import("Containers/layout"),
	{ ssr: true },
);
const Breadcrumb = dynamic(
	() => import("@fdn/breadcrumb"),
	{ ssr: false },
);

const PrivacyPolicy = (props) => {

	const data = props;
	const { query: { device } } = data;

	return (
		<Layout
			home
			title="Femaledaily"
			metaTitle="Privacy Policy"
			typeNavbarSecondary="type-3"
			titleNavbar="Privacy Policy"
			ismobile={data.isMobile}
			self={data.getStoreSelf}
			categoryDesktop={data && data.storeCategoryDesktop}
			device={device}
		>
			<div className={!data.isMobile ? "container" : ""}>
				{data?.isMobile && (device !== "1" && device !== "2") && (
					<Breadcrumb
						isHeader
						isMobile={data.isMobile}
						breadcrumbs={["privacy-policy"]}
						destinationUrl={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/category`}
						margin={data.isMobile ? "20px 20px 0 20px" : "15px 0 30px 0"}
						textTransform="capitalize"
						fontFamily="Creato Display, sans-serif"
						color="#000"
						fontWeightActive="700"
					/>
				)}
				<div className={data.isMobile ? "content" : "content desktop"}>
					<h1 className="title-page">Kebijakan Privasi</h1>
					<div className="parent">
						<div className="child">
							<p>
								Kebijakan Privasi ini mengatur cara Female Daily Network mengumpulkan, menggunakan, memelihara, dan mengungkapkan informasi yang dikumpulkan dari pengguna (masing-masing disebut sebagai “Pengguna”) situs web www.femaledaily.com (“Situs”). Kebijakan privasi ini berlaku untuk Situs dan semua produk dan layanan yang ditawarkan oleh Female Daily Network.
							</p>
						</div>
						<div className="child">
							<h2>Informasi identifikasi pribadi</h2>
							<p>
								Kami dapat mengumpulkan informasi identifikasi pribadi dari Pengguna dalam berbagai cara, termasuk, namun tidak terbatas pada, saat Pengguna mengunjungi situs kami, mendaftar di situs, berlangganan newsletter, dan sehubungan dengan aktivitas, layanan, fitur, atau sumber lain yang kami sediakan di Situs kami. Pengguna dapat dimintai, jika diperlukan, nama, alamat email, alamat surat, nomor telepon. Namun, pengguna dapat mengunjungi Situs kami secara anonim. Kami akan mengumpulkan informasi identifikasi pribadi dari Pengguna hanya jika mereka secara sukarela mengirimkan informasi tersebut kepada kami. Pengguna selalu dapat menolak untuk memberikan informasi identifikasi pribadi, hanya saja hal itu dapat membatasi Pengguna dalam melakukan aktivitas tertentu pada Situs.
							</p>
						</div>
						<div className="child">
							<h2>Informasi identifikasi non-pribadi</h2>
							<p>
								Kami dapat mengumpulkan informasi identifikasi non-pribadi tentang Pengguna setiap kali mereka berinteraksi dengan Situs kami. Informasi identifikasi non-pribadi dapat mencakup nama browser, jenis komputer, dan informasi teknis tentang sarana koneksi Pengguna ke Situs kami, seperti sistem operasi dan penyedia layanan Internet yang digunakan dan informasi serupa lainnya.
							</p>
						</div>
						<div className="child">
							<h2>Bagaimana kami menggunakan informasi yang dikumpulkan</h2>
							<li>
								<p>Female Daily Network dapat mengumpulkan dan menggunakan informasi pribadi Pengguna untuk tujuan berikut:</p>
								<ul className="child">
									<li className="bullet">
										Untuk mempersonalisasi pengalaman pengguna. Kami dapat menggunakan informasi secara agregat untuk memahami bagaimana Pengguna kami sebagai grup menggunakan layanan dan sumber daya yang disediakan di Situs kami.
									</li>
									<li className="bullet">
										Untuk meningkatkan layanan Situs kami. Kami dapat menggunakan masukan yang Anda berikan untuk meningkatkan produk dan layanan kami.
									</li>
									<li className="bullet">
										Untuk menjalankan promosi, kontes, survei, atau fitur Situs lainnya.
									</li>
									<li className="bullet">
										Untuk mengirimkan informasi kepada Pengguna yang mereka setujui untuk terima tentang topik yang menurut kami menarik bagi mereka.
									</li>
									<li className="bullet">
										Untuk mengirim email berkala. Kami dapat menggunakan alamat email Pengguna untuk mengirim informasi dan pembaruan yang berkaitan dengan pesanan mereka. Hal ini juga dapat digunakan untuk menanggapi pertanyaan-pertanyaan, dan/atau permintaan lainnya. Jika Pengguna memutuskan untuk ikut serta ke milis kami, mereka akan menerima email yang mungkin berisi berita perusahaan, pembaruan, informasi produk atau layanan terkait, dll. Jika sewaktu-waktu Pengguna ingin berhenti berlangganan  email di masa mendatang, kami menyertakan rincian petunjuk berhenti berlangganan di bagian bawah setiap email.
									</li>
								</ul>
							</li>
						</div>
						<div className="child">
							<h2>Bagaimana kami melindungi informasi Anda</h2>
							<p>
								Kami menerapkan praktik pengumpulan, penyimpanan, dan pemrosesan data yang sesuai serta langkah-langkah keamanan untuk melindungi dari akses tidak sah, perubahan, pengungkapan, atau penghancuran terhadap informasi pribadi, nama pengguna, kata sandi, informasi transaksi, dan data Anda yang disimpan di Situs kami.
							</p>
						</div>
						<div className="child">
							<h2>Berbagi informasi pribadi Anda</h2>
							<p>
								Kami tidak menjual, memperdagangkan, atau menyewakan informasi identifikasi pribadi Pengguna kepada orang lain. Kami dapat membagikan informasi demografi agregat umum yang tidak terkait dengan informasi identifikasi pribadi apa pun terkait pengunjung dan pengguna dengan mitra bisnis kami, afiliasi tepercaya, dan pengiklan untuk tujuan yang diuraikan di atas. Kami dapat menggunakan penyedia layanan pihak ketiga untuk membantu kami mengoperasikan bisnis dan Situs atau mengelola aktivitas atas nama kami, seperti mengirimkan milis atau survei. Kami dapat membagikan informasi Anda dengan pihak ketiga ini untuk tujuan terbatas tersebut asalkan Anda telah memberikan izin kepada kami.
							</p>
						</div>
						<div className="child">
							<h2>Situs web pihak ketiga</h2>
							<p>
								Pengguna dapat menemukan iklan atau konten lain di Situs kami yang tertaut ke situs dan layanan mitra kami, pemasok, pengiklan, sponsor, pemberi lisensi, dan pihak ketiga lainnya. Kami tidak mengontrol konten atau tautan yang muncul di situs ini dan tidak bertanggung jawab atas praktik yang dilakukan oleh situs web yang ditautkan ke atau dari Situs kami. Selain itu, situs atau layanan ini, termasuk konten dan tautannya, mungkin terus berubah. Situs dan layanan ini mungkin memiliki kebijakan privasi dan kebijakan layanan pelanggan mereka sendiri. Penjelajahan dan interaksi di situs web lain mana pun, termasuk situs web yang memiliki tautan ke Situs kami, tunduk pada syarat dan kebijakan situs web itu sendiri.
							</p>
						</div>
						<div className="child">
							<h2>Periklanan</h2>
							<p>
								Iklan yang muncul di situs kami dapat dikirimkan ke Pengguna oleh mitra periklanan, yang dapat mengatur cookie. Cookie ini memungkinkan server iklan untuk mengenali komputer Anda setiap kali mereka mengirimi Anda iklan online untuk mengumpulkan informasi identifikasi non pribadi tentang Anda atau orang lain yang menggunakan komputer Anda. Informasi ini memungkinkan jaringan iklan, antara lain, menayangkan iklan bertarget yang mereka yakini paling menarik bagi Anda. Kebijakan privasi ini tidak mencakup penggunaan cookie oleh pengiklan mana pun.
							</p>
						</div>
						<div className="child">
							<h2>Kepatuhan terhadap tindakan perlindungan privasi online anak-anak</h2>
							<p>
								Melindungi privasi anak-anak sangat penting. Oleh karena itu, kami tidak pernah mengumpulkan atau menyimpan informasi di Situs kami dari mereka yang kami tahu berusia di bawah 13 tahun, dan tidak ada bagian dari situs web kami yang bertujuan untuk menarik siapa pun di bawah 13 tahun.
							</p>
						</div>
						<div className="child">
							<h2>Perubahan pada kebijakan privasi ini</h2>
							<p>
								Female Daily Network memiliki keleluasaan untuk memperbarui kebijakan privasi ini kapan saja. Ketika kami melakukannya, kami akan memposting pemberitahuan di halaman utama Situs kami dan mengirimkan email kepada Anda. Kami mendorong Pengguna untuk sering memeriksa halaman ini untuk setiap perubahan agar tetap mengetahui tentang bagaimana kami membantu melindungi informasi pribadi yang kami kumpulkan. Anda mengakui dan setuju bahwa Anda bertanggung jawab untuk meninjau kebijakan privasi ini secara berkala dan menyadari adanya modifikasi.
							</p>
						</div>
						<div className="child">
							<h2>Penerimaan Anda terhadap persyaratan ini</h2>
							<p>
								Dengan menggunakan Situs ini, Anda menandakan penerimaan Anda terhadap kebijakan ini. Jika Anda tidak menyetujui kebijakan ini, harap jangan gunakan Situs kami. Anda yang terus menggunakan Situs ini setelah adanya perubahan pada kebijakan ini akan dianggap sebagai persetujuan Anda atas perubahan tersebut.
							</p>
						</div>
						<div className="child">
							<h2>Hubungi kami</h2>
							<p>
								Jika Anda memiliki pertanyaan tentang Kebijakan Privasi ini, praktik situs ini, atau hubungan Anda dengan situs ini, silakan hubungi kami di:
							</p>
							<address>
								Female Daily Network
								<br />
								femaledaily.com
								<br />
								PT. Daily Dinamika Kreasi (Female Daily HQ)
								<br />
								Jl. Kemang Raya No. 2 Jakarta Selatan 12730
								<br />
								+62-21-79182121
								<br />
								hello@femaledaily.com
							</address>
							<br />
							<p>Dokumen ini terakhir diperbarui pada 28 Desember 2022</p>
						</div>
					</div>
				</div>
				<style jsx>
					{`
						.content .title-page {
							font-weight: 600;
							font-style: normal;
							font-size: 24px;
							line-height: 32px;
							padding: ${data.isMobile ? "0 20px" : "0"};
						}
						.content.desktop .title-page {
							font-size: 36px;
							line-height: 36px;
						}
						.content div.parent {
							margin: 0 0 30px 0;
							list-style-type: none;
							padding: ${data.isMobile ? "0 20px" : "0"};
						}
						.content div.parent p.title {
							font-weight: 600;
							font-style: normal;
							font-size: 16px;
							line-height: 16px;
							margin: 0 -20px;
							padding: 0;
							display: flex;
							align-items: center;
						}
						.content.desktop div.parent p.title {
							font-size: 20px;
							line-height: 24px;
						}
						.content div.parent p.title span {
							margin: 0 0 0 5px;
						}
						.content div.parent div.child h2 {
							font-weight: 600;
							font-style: normal;
							font-size: 16px;
							line-height: 22px;
						}
						.content div.parent div.child p {
							margin: 0;
							padding: 0;
							font-weight: 400;
							font-style: normal;
							font-size: 14px;
							line-height: 22px;
						}
						.content div.parent div.child li ul.child {
							padding-inline-start: 20px;
						}
						.content div.parent div.child li ul.child li.bullet {
							margin: 10px 0;
							font-weight: 400;
							font-style: normal;
							font-size: 14px;
							line-height: 22px;
						}
						.content div.parent div.child address {
							margin: 10px 0;
							font-size: 14px;
						}
					`}
				</style>
			</div>
		</Layout>
	);

};

export const getServerSideProps = wrapper.getServerSideProps(
	async ({ store, req, query }) => {

		let userAgent;
		let cookies;
		let authorization = null;
		let usrname = null;

		if (req) {

			// if you are on the server and you get a "req" property from your context
			userAgent = req.headers["user-agent"]; // get the user-agent from the headers

		} else {

			// if you are on the client you can access the navigator from the window object
			userAgent = navigator.userAgent;

		}

		const isMobile = Boolean(
			userAgent.match(
				/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i,
			),
		);

		const isServer = !!req;

		if (req.headers.cookie) {

			cookies = cookie.parse(req.headers.cookie);
			authorization = cookies.token;
			usrname = cookies.usrname;

		}

		await store.dispatch(
			loadSelf({
				payload: {
					api_env: process.env.NEXT_PUBLIC_NODE_ENV,
					env: Env.HEADERS,
					usrname,
					Authorization: authorization,
					is_server: isServer,
				},
			}),
		);

		await store.dispatch(
			loadCategoryDesktop({
				payload: {
				},
			}),
		);

		store.dispatch(END);
		await store.sagaTask.toPromise();

		const categoryNavigationDesktop = [];
		const brands = {
			id: 200,
			name: "Brands",
			slug: "brands",
			items: [],
		};

		const getStoreSelf = store.getState().storeSelf && typeof store.getState().storeSelf.data !== "undefined"
			? store.getState().storeSelf
			: null;

		const getStoreCategoryDesktop = store.getState().storeCategoryDesktop.data && typeof store.getState().storeCategoryDesktop.data.data !== "undefined"
			? store.getState().storeCategoryDesktop.data
			: null;

		getStoreCategoryDesktop
		&& getStoreCategoryDesktop.data[0]
		&& getStoreCategoryDesktop.data[0].children_data
		&& getStoreCategoryDesktop.data[0].children_data.filter((val) => val.include_in_menu === "1").map((item) => {

			categoryNavigationDesktop.push({
				id: item.entity_id,
				name: item.category_name,
				slug: item.category_path,
				items: item.children_data.length > 0
					? item.children_data.map((child) => ({
						id: child.entity_id,
						name: child.category_name,
						slug: child.category_path,
						items: child.children_data.length > 0
							? child.children_data.map((childs) => ({
								id: childs.entity_id,
								name: childs.category_name,
								slug: childs.category_path,
								items: childs.children_data.length > 0
									? childs.children_data.map((lastChilds) => ({
										id: lastChilds.entity_id,
										name: lastChilds.category_name,
										slug: lastChilds.category_path,
									})) : [],
							})) : [],
					})) : [],
			});

		});
		categoryNavigationDesktop.splice(1, 0, brands);

		return {
			props: {
				query,
				isMobile,
				getStoreSelf,
				storeCategoryDesktop: categoryNavigationDesktop || null,
			}, // will be passed to the page component as props
		};

	},
);

export default PrivacyPolicy;
